/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Methods for calculating quorum */
export enum QuorumMethod {
  Absolute,
  Relative,
  Weighted,
  Dynamic,
}

export type QuorumMethodArgs = QuorumMethod;

export function getQuorumMethodEncoder(): FixedSizeEncoder<QuorumMethodArgs> {
  return getEnumEncoder(QuorumMethod);
}

export function getQuorumMethodDecoder(): FixedSizeDecoder<QuorumMethod> {
  return getEnumDecoder(QuorumMethod);
}

export function getQuorumMethodCodec(): FixedSizeCodec<
  QuorumMethodArgs,
  QuorumMethod
> {
  return combineCodec(getQuorumMethodEncoder(), getQuorumMethodDecoder());
}
